/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuInputRange_itemSearch$ref = any;
export type SbSharedRefineMenuInputRangeCurrency_itemSearch$ref = any;
export type SbSharedRefineMenuInputRangeCurrency_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedRefineMenuInputRange_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuInputRangeCurrency_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuInputRangeCurrency_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '5b5209934a174c24d6951bf82e480726';
export default node;
